module.exports = __webpack_public_path__ + "media/assets/images/blog/agile-errors-9e313f93746d340a17da4757ee0a24a6.jpg";